const SESSION_ID = "sessionId"
const UUID = "uuid"
const USERNAME = "username"
const PLAYBACK_URL = "playback_url"
const ENTITLEMENT_NAME = "entitlement_name"
const FCM_TOKEN = "fcm_token"
const FCM_PROMPT_COUNT = "fcm_prompt_count"

const FCM_MAX_PROMPTS = 3

export const fetchSessionId = () => {
    return localStorage.getItem(SESSION_ID)
}

export const saveSessionId = (sessionId) => {
    if (sessionId == null) {
        localStorage.removeItem(SESSION_ID)
    }
    else {
        localStorage.setItem(SESSION_ID, sessionId)
    }
}

export const saveDeviceUuid = (uuid) => {
    if (uuid == null) {
        localStorage.removeItem(UUID)
    }
    else {
        localStorage.setItem(UUID, uuid)
    }
}

export const getSavedDeviceUuid = () => {
    return localStorage.getItem(UUID)
}

export const saveUsername = (username) => {
    if (username == null) {
        localStorage.removeItem(USERNAME)
    }
    else {
        localStorage.setItem(USERNAME, username)
    }
}

export const getSavedUsername = () => {
    return localStorage.getItem(USERNAME)
}

export const savePlaybackUrl = (playbackUrl) => {
    if (playbackUrl == null) {
        localStorage.removeItem(PLAYBACK_URL)
    }
    else {
        localStorage.setItem(PLAYBACK_URL, playbackUrl)
    }
}

export const getPlaybackUrl = () => {
    return localStorage.getItem(PLAYBACK_URL)
}

export const saveEntitlementName = (entitlementName) => {
    if (entitlementName == null) {
        localStorage.removeItem(ENTITLEMENT_NAME)
    }
    else {
        localStorage.setItem(ENTITLEMENT_NAME, entitlementName)
    }
}

export const getEntitlementName = () => {
    return localStorage.getItem(ENTITLEMENT_NAME)
}

export const saveFcmToken = (token) => {
    if (token == null) {
        localStorage.removeItem(FCM_TOKEN)
    } else {
        localStorage.setItem(FCM_TOKEN, token)
    }
}

export const getFcmToken = () => {
    return localStorage.getItem(FCM_TOKEN)
}

export const clearFcmToken = () => {
    localStorage.removeItem(FCM_TOKEN)
}

/**
 * Returns how many times we have shown the notification permission prompt.
 */
export const getPermissionPromptCount = () => {
    return parseInt(localStorage.getItem(FCM_PROMPT_COUNT) || '0', 10)
}

/**
 * Increment prompt counter each time we show the permission dialog.
 */
export const incrementPermissionPromptCount = () => {
    const current = getPermissionPromptCount()
    localStorage.setItem(FCM_PROMPT_COUNT, current + 1)
}

/**
 * Determines whether the app should prompt the user for notification permission.
 * Rules:
 *  - Returns false if the browser doesn't support notifications
 *  - Returns false if the user has already denied (browser-level)
 *  - Returns false if the user already granted permission (no need to ask again)
 *  - Returns false if we have already asked FCM_MAX_PROMPTS times
 *  - Returns true otherwise
 */
export const shouldAskNotificationPermission = () => {
    if (!('Notification' in window) || !('serviceWorker' in navigator)) return false
    if (Notification.permission === 'denied') return false
    if (Notification.permission === 'granted') return false
    return getPermissionPromptCount() < FCM_MAX_PROMPTS
}
